import { Component } from '@angular/core';

@Component({
  selector: 'app-angle-down-icon',
  standalone: true,
  templateUrl: './angle-down-icon.component.html',
})
export class AngleDownIconComponent {}
